import { createBoxKitchenAppliance } from "./C1_createBoxKitchenAppliance";

const Oven = createBoxKitchenAppliance({
  id: "oven",
  iconKind: "oven",
  description: { en: "Oven", de: "Backofen" },
  centerLabel: { en: "O", de: "B" },
});

export default Oven;
